import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

/**
 * WEB-1001 — the design-system text field (DS 1.9.0 `.a-input`).
 *
 * 40 high with 15px text on fine pointers; 44 with 16px text on coarse
 * pointers (a native input can't carry the `::before` hit box, and iOS Safari
 * zooms a focused field under 16px). Keyed to `(pointer: coarse)`, never to
 * viewport width. `invalid` sets `aria-invalid`, which paints the danger edge.
 */
export interface InputProps extends React.ComponentPropsWithoutRef<'input'> {
  invalid?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, type = 'text', ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      {...props}
      aria-invalid={invalid || props['aria-invalid'] || undefined}
      className={cn('a-input', className)}
    />
  );
});

/** Multi-line `.a-input`: min 96 high, 15px fine / 16px coarse text. */
export interface TextareaProps extends React.ComponentPropsWithoutRef<'textarea'> {
  invalid?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      {...props}
      aria-invalid={invalid || props['aria-invalid'] || undefined}
      className={cn('a-input', className)}
    />
  );
});
